var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdminAddNewDocument(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0H24V24H0z",
    transform: "translate(-995 -1283.001) translate(995 1283.001)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.918 18.655h12.863a.187.187 0 0 0 .13-.053.184.184 0 0 0 .054-.13v-1.285a.185.185 0 0 0-.184-.187h-8.358v-.827a.183.183 0 0 0-.183-.183H5.918a.188.188 0 0 0-.131.054.182.182 0 0 0-.053.131v2.3a.183.183 0 0 0 .053.13.185.185 0 0 0 .131.05z",
    transform: "translate(-995 -1283.001) translate(995.001 1272.01) translate(-4.356)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.935 34.943a6.007 6.007 0 0 1 2.094-4.56H.183a.187.187 0 0 0-.138.063.183.183 0 0 0-.045.144l1.1 8.76a.181.181 0 0 0 .181.161h12.757a6.006 6.006 0 0 1-2.103-4.568z",
    transform: "translate(-995 -1283.001) translate(995.001 1272.01) translate(0 -10.931)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.429 26.479A5.519 5.519 0 1 0 64.948 32a5.518 5.518 0 0 0-5.519-5.521zm2.4 6.351h-1.567v1.57a.833.833 0 0 1-1.666 0v-1.57h-1.565a.832.832 0 0 1 0-1.665H58.6V29.6a.833.833 0 0 1 1.666 0v1.566h1.566a.832.832 0 1 1 0 1.665z",
    transform: "translate(-995 -1283.001) translate(995.001 1272.01) translate(-40.949 -7.966)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminAddNewDocument);
export default __webpack_public_path__ + "static/media/admin-add-new-document.c9eec6771ed03f2a8a08dacbbc22f3e0.svg";
export { ForwardRef as ReactComponent };